import { render, staticRenderFns } from "./dataformname.vue?vue&type=template&id=153ec73b&scoped=true&"
import script from "./dataformname.vue?vue&type=script&lang=js&"
export * from "./dataformname.vue?vue&type=script&lang=js&"
import style0 from "./dataformname.vue?vue&type=style&index=0&id=153ec73b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ec73b",
  null
  
)

export default component.exports